import {
  GAPageView,
  GASendEvent,
} from "features/googleAnalytics/googleAnalytics";
import User from "models/user/user";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { isRolePresent } from "utilities/generalUtility";

export default function RouteWithSubRoutes({ route, userData }) {
  const downloadEvent = (value) => {
    const eventOptions = {
      category: "Click",
      action: value,
      label: value,
    };
    GASendEvent(eventOptions);
  };
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const declined = async () => {
    try {
      const body = {
        email: queryParams.get("email").replace(/ /g, "+"),
        diaryId: parseInt(queryParams.get("diaryId")),
      };
      await NetworkCall.fetch(Request.declinedDiaryInvite(body));
      queryParams.delete("isRegistered");
      queryParams.delete("email");

      const updatedQueryString = queryParams.toString();
      window.history.replaceState(null, null, `?${updatedQueryString}`);
    } catch (error) {}
  };

  useEffect(() => {
    if (queryParams.get("isRegistered") === "True") {
      declined();
    }
  }, []);

  useEffect(() => {
    GAPageView(location.pathname + location.search);
    if (!navigator.onLine) navigate("/404");
  }, [location]);

  if (
    !route.authenticated ||
    (route.authenticated && User.isTokenAvailable())
  ) {
    if (
      (["/login", "/forgot-password", "/set-password", "/register"].includes(
        route.path
      ) &&
        User.isTokenAvailable()) ||
      (route.path === "/sub-info" && User.getCardStatus() !== "false")
    ) {
      return (
        <Navigate
          replace
          to={{
            pathname: "/journal-request",
            state: { from: route.location },
            search:
              queryParams.get("diaryId") &&
              `?diaryId=${queryParams.get(
                "diaryId"
              )}&diaryTopicId=${queryParams.get("diaryTopicId")}`,
          }}
        />
      );
    } else if (
      route.path !== "/sub-info" &&
      route.path !== "/personality" &&
      User.getCardStatus() === "false" &&
      userData?.subscriptionStatus === "pending_payment"
    ) {
      return (
        <Navigate
          replace
          to={{
            pathname: "/sub-info",
            state: { from: route.location },
            search:
              queryParams.get("diaryId") &&
              `?diaryId=${queryParams.get(
                "diaryId"
              )}&diaryTopicId=${queryParams.get("diaryTopicId")}`,
          }}
        />
      );
    } else if (
      route.path !== "/account-settings" &&
      route.path !== "/sub-info" &&
      route.path !== "/personality" &&
      User.isTokenAvailable() &&
      userData?.subscriptionStatus &&
      userData?.subscriptionStatus !== "active" &&
      userData?.subscriptionStatus !== "trialing"
    ) {
      return <Navigate replace to={{ pathname: "/account-settings" }} />;
    }

    if (navigator.onLine && route.path === "/404") {
      return <Navigate to={"/"} replace />;
    }

    if (!navigator.onLine && route.path !== "/404") {
      throw new Error("Something went wrong");
    }

    // Check roles
    const hasRole = isRolePresent(route.roles, User.roles());
    if (hasRole) {
      downloadEvent(route?.name);
      const component = (
        <route.component {...route} route={route}></route.component>
      );
      return route.layout ? (
        <route.layout>{component}</route.layout>
      ) : (
        component
      );
    } else {
      return <Navigate replace to={{ pathname: "/unauthorized" }} />;
    }
  } else {
    return (
      <Navigate
        replace
        to={{
          pathname: "/login",
          state: { from: route.location },
          search:
            queryParams.get("diaryId") &&
            `?diaryId=${queryParams.get(
              "diaryId"
            )}&diaryTopicId=${queryParams.get("diaryTopicId")}`,
        }}
      />
    );
  }
}
